export enum RouteNames {
    LOGIN = 'login',
    PREDICTION = 'prediction',
};
